module.exports = __webpack_public_path__ + "img/shengpizhong.14cb62f0.png";